module.exports = __webpack_public_path__ + "static/media/stephanie-stelko.f9ea5494.jpg";